export default {
  OPEN: 'OPEN_SNACKBAR',
  CLOSE: 'CLOSE_SNACKBAR',
  UPDATE: 'UPDATE_SNACKBAR'
};